import $ from "jquery";

$(function() {

    initSuggestionsButton();

});

// window.customUpdateBasket = function (data) {
//
//     // This function is called by the updateBasket routine in the ecommerce package
//     // and can be used to make project specific changes to the basket form.
//
//     console.log('customUpdateBasket');
//
// //     // Run the customUpdateBasket routine in product-prices.js
// //     doCustomUpdateBasket(data);
// //
// //     showBasketChanged();
// //
// //     // // Check if there is a flash message already displayed
// //     // let hasFlashMessage = ($('.flash-message').length > 0);
// //     // let hasNewMessage = (data.message != '');
// //     //
// //     // if (hasFlashMessage && hasNewMessage) {
// //     //     $('.flash-message').text(data.message);
// //     // } else if (hasFlashMessage != hasNewMessage) {
// //     //     // We either have a new message, or we need to clear the old one - needs a screen refresh
// //     //     location.reload();
// //     // }
//
// }

// window.customUpdateBasket = function (data) {
//
//     console.log('basket.js->customUpdateBasket');
//
//     // if ((basketDetails.data.has_insufficient_stock_items) || (basketDetails.data.has_out_of_stock_items)) {
//     //     $('form.custom-order-details').addClass('hidden');
//     // } else {
//     //     $('form.custom-order-details').removeClass('hidden');
//     // }
//
// }

window.showBasketChanged = function () {

    //console.log('showBasketChanged');

    let alert = '<div id="basketUpdated" style="display:none;"><div><p>Basket Updated</p></div><div>Your basket has been updated</div></div>';

    $('#main').append(alert);
    $('#basketUpdated').fadeIn(300);

    setTimeout(function() {
        $('#basketUpdated').fadeOut(300, function() { $(this).remove(); });
    }, 3000);
}


function initSuggestionsButton() {

    $('.suggestions-button').unbind('click');

    $('.suggestions-button').on('click', function() {

        if ($(this).hasClass('show')) {
            // We are showing the suggestions table
            $(this).parent().find('.suggestions-table').removeClass('hide');
            $(this).removeClass('show').text('Hide suggestions');
        } else {
            // We are hiding the suggestions
            $(this).parent().find('.suggestions-table').addClass('hide');
            $(this).addClass('show').text('Show suggestions');
        }

    });

}
